<template lang="pug">
.change-container.fix
  div(v-if="!change.isDropshipping")
    img.logo(:src="`${imagePath}/others/logo-print-${change.brand}.jpg`")
    .sender-info-container
      .sender-info.capitalize {{ data[change.brand].name  }} - {{ data[change.brand].documentNumber }}
      .sender-info.capitalize {{ data[change.brand].address }} - {{ data[change.brand].phone }}

  .container-zimple(v-else)
    img.logo-zimple(:src="`${imagePath}/others/logo-zimple.png`")
    .sender-info-container
      .sender-info Zimple Life SAS
      .sender-info 901.524.561-8
      .sender-info Calle 37B Sur #28c 01
      .sender-info 3245452675

  img.change-conveyor(v-if="change.conveyor && (change.conveyor !== 'sahet' && change.conveyor !== 'bassica')" :src="`${imagePath}/conveyors/${change.conveyor}.png`")
  .cod-delivery(v-if="change.methodPay === 'dropshipping' && change.userPayConveyor") Envío al Cobro

  .change-total(v-if="change.methodPay === 'cod' || change.cod || totalCOD > 0")
    span(v-if="totalCOD > 0") Cobrar: {{ money(totalCOD)}}
    span(v-else) Cobrar: {{ money(total - discount + addons) }}

  .change-info
    QRCode(:text="'c' + change.change" width="100")
    .change.uppercase C{{ change.change }} (Cambio) - {{ change.order }}
    .change-location.capitalize {{ buyerRemit.location }} - {{ buyerRemit.department }}
    .change-delivery-time {{ deliverySchedule[change.deliveryTime] }}

  .buyer-info
    .buyer-name.capitalize Nombre: {{ buyerRemit.name }}
    .buyer-phones Teléfonos: {{ buyerRemit.phones.join(', ') }}
    .buyer-address.uppercase Dirección: {{ buyerRemit.address }}
    .buyer-dni(v-if="change.dni") Cédula: {{ change.dni }}

    .change-observations
      ol.change-observation(v-for="(observation, index) in change.observations" v-if="observation.type === 'delivery'")
        li {{ observation.observation }}

  div(v-if="change.isDropshipping")
    .wait(v-if="!change.userPayConveyor || change.cod") Esperar Remite...
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import QRCode from '@/components/elements/QRCode'
import { getBuyerRemitFromOrder } from '@/helpers/remit'

export default {
  name: 'ChangePrintReturnAddress',

  mixins: [mForm, mFilters],

  components: { QRCode },

  props: {
    change: Object,
    remitOnly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      deliverySchedule: {
        '8-21': '🌞 8:00 a.m. - 🌚 9:00 p.m.',
        '8-20': '🌞 8:00 a.m. - 🌛 8:00 p.m.',
        '8-13': '🌞 8:00 a.m. - 😎 1:00 p.m.',
        '13-20': '😎 1:00 p.m. - 🌛 8:00 p.m.',
        '13-21': '😎 1:00 p.m. - 🌚 9:00 p.m.'
      }
    }
  },

  computed: {
    totals () {
      return this.getTotals(this.change.cart)
    },

    total () {
      return this.getTotal(this.change, this.totals)
    },

    discount () {
      return this.getDiscount(this.change, this.total)
    },

    addons () {
      return this.getAddons(this.change)
    },

    totalCOD () {
      const change = this.change
      const { payManual } = change
      let total = 0

      for (let i = 0; i < payManual.length; i++) {
        const pay = payManual[i]

        if (pay.methodPay === 'cod') total += pay.value || 0
      }

      return total
    },

    data () {
      return this.$store.state.variables.data
    },

    buyerRemit () {
      return getBuyerRemitFromOrder(this.change, { remitOnly: this.remitOnly })
    },

    quantitySale () {
      return 3
    }
  }
}
</script>

<style lang="stylus" scoped>
.change-container
  background-color white
  color black
  border .3mm dashed black
  width 7.1cm
  display inline-block
  padding 5mm
  vertical-align top

.logo
  height 6mm
  display block
  margin-bottom 1mm

.sender-info
  font-size 3.3mm
  font-weight 600

.buyer-info, .change-info
  margin-top 5mm

.change
  font-size 5mm
  font-weight 600

.change-conveyor
  height 6mm
  margin-top 5mm
  filter brightness(0)

.change-location
  font-size 4mm
  font-weight 600

.change-delivery-time
  font-size 4mm

.change-total
  font-size 5mm
  margin-top 4mm
  font-weight 600
  text-decoration underline

.change-observations
  margin-top 4mm
  font-size 4mm
  list-style-type upper-alpha

.change-observation
  padding 0em 0 0em 1em

.change-observation > li
  list-style decimal

.buyer-name, .buyer-phones, .buyer-address, .buyer-dni
  font-size 4mm

.fix
  page-break-inside avoid

.cod-delivery
  font-size 5mm
  margin-top 4mm
  border 1mm solid black
  border-radius 2mm
  display inline-block
  padding 2mm
  font-weight 600

.wait
  font-size 4mm
  text-decoration underline
  font-weight 600

.container-zimple
  display flex
  gap 2mm
</style>



// WEBPACK FOOTER //
// src/components/pages/print/ChangePrintReturnAddressOld.vue